import pikkoHalloween from '../styles/img/logo/pikko-halloween.json';
import pikkodefault from '../styles/img/logo/pikkoAnimation.json';
import pikkoNoel from '../styles/img/logo/pikko-noel.json';

export const LottieLogo = {
  halloween: { image: pikkoHalloween, loop: true },
  default: { image: pikkodefault, loop: false },
  noel: { image: pikkoNoel, loop: true },
};
